import React from "react"

import globalStyles from "../../../../App.module.scss"
import {Prism as SyntaxHighlighter} from "react-syntax-highlighter"
import {dracula} from "react-syntax-highlighter/dist/cjs/styles/prism"

let sumExample = `# Sum the 3rd column of a CSV
awk -F, '{ total += $3 } END { print total }' sales.csv`

let filterExample = `# Print lines where the 5th (whitespace-separated) field exceeds 90
awk '$5 > 90 { print $1, $5 }' metrics.log`

let headerExample = `# Skip the header row, print columns 1 and 3
awk 'NR > 1 { print $1, $3 }' data.csv`

export default function AwkBasics() {
    return (
        <div className={globalStyles.article}>
            <h1>awk basics</h1>
            <p>Line-oriented text processor built around <code>pattern {"{ action }"}</code> pairs — for every
                input line, if the pattern matches, run the action.</p>

            <div className={globalStyles.styledTable}>
                <table style={{minWidth: '450px'}}>
                    <thead>
                    <tr>
                        <th>Variable</th>
                        <th>Meaning</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td><code>$0</code></td>
                        <td>The whole current line</td>
                    </tr>
                    <tr>
                        <td><code>$1</code>, <code>$2</code>, ...</td>
                        <td>Individual fields (split by whitespace by default)</td>
                    </tr>
                    <tr>
                        <td><code>NF</code></td>
                        <td>Number of fields on the current line</td>
                    </tr>
                    <tr>
                        <td><code>NR</code></td>
                        <td>Current line (record) number</td>
                    </tr>
                    <tr>
                        <td><code>-F,</code></td>
                        <td>Use <code>,</code> as the field separator instead of whitespace</td>
                    </tr>
                    </tbody>
                </table>
            </div>

            <h3>Summing a column</h3>
            <SyntaxHighlighter
                children={sumExample}
                style={dracula}
                PreTag="div"
                language={'bash'}
            />

            <h3>Filtering by a field value</h3>
            <SyntaxHighlighter
                children={filterExample}
                style={dracula}
                PreTag="div"
                language={'bash'}
            />

            <h3>BEGIN / END blocks and NR</h3>
            <p><code>BEGIN {"{ ... }"}</code> runs once before any input, <code>END {"{ ... }"}</code> once
                after — useful for headers, totals, and skipping rows.</p>
            <SyntaxHighlighter
                children={headerExample}
                style={dracula}
                PreTag="div"
                language={'bash'}
            />
        </div>
    )
}
